var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ajaxSend } from '../../../api/api';
const v2BasePath = '/v2/templating/templates';
const v2TranslationsPath = '/v2/templating/templatetranslations';
const v3BasePath = '/v3/templates';
export function getTemplates(params = {}) {
    return ajaxSend({
        path: v3BasePath,
        params,
    });
}
export function createTemplate(template) {
    const { name, content, subject, type } = template;
    return ajaxSend({
        method: 'POST',
        path: `${v2BasePath}`,
        data: {
            name: name,
            content: content,
            subject: subject,
            type: type,
        },
    });
}
export function updateTemplate(templateId, payload) {
    const { updates, deletes } = payload;
    const patch = {
        updates: updates,
        deletes: deletes,
    };
    return ajaxSend({
        path: `${v2BasePath}/${encodeURIComponent(templateId)}`,
        method: 'PATCH',
        data: patch,
    });
}
export function readTemplateById(templateId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield ajaxSend({
                path: `${v2BasePath}/${encodeURIComponent(templateId)}`,
                method: 'GET',
            });
        }
        catch (error) {
            return Promise.resolve(undefined);
        }
    });
}
export function removeTemplate(templateId) {
    return ajaxSend({
        path: `${v2BasePath}/${encodeURIComponent(templateId)}`,
        method: 'DELETE',
    });
}
export function updateTemplateTranslations(templateId, translations) {
    return ajaxSend({
        path: `${v2TranslationsPath}/${encodeURIComponent(templateId)}`,
        method: 'PATCH',
        data: { translations },
    });
}
export function removeTemplateTranslations(templateId, localesToDelete) {
    return ajaxSend({
        path: `${v2TranslationsPath}/${encodeURIComponent(templateId)}`,
        method: 'DELETE',
        data: {
            localesToDelete,
        },
    });
}
